import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { CclDrawerService, CclNavbarFooterService, CclMessageService, CclNotifyService } from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Subscription } from "rxjs";
import { cloneDeep } from "lodash";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";

@Component({
    selector: "app-tabs-page",
    templateUrl: "./tabs-page.view.html",
    styleUrls: []
})
export class TabsPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit, OnDestroy {
    subscription: Subscription;
    tabConfigObj: any;
    tabConfig: any;
    tabStyles: any = [
        {
            label: "Tab",
            code: "tab"
        },
        {
            label: "Underline",
            code: "underline"
        }
    ];

    tabData: any = [
        {
            label: "Event Days",
            code: "eventDays"
        },
        {
            label: "Session Days",
            code: "sessionDays"
        }
    ];

    today: any = new Date();
    filterSetupObj: any = {};
    constructor(
        public sharedService: SharedService,
        private drawerService: CclDrawerService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService,
        private notifyService: CclNotifyService,
    ) {
        super(sharedService);
        this.sharedService.currentLayoutSection = "tabs";
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveTabConfig(message));
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.tabConfig = cloneDeep(this.sharedService.tabConfig);
        this.sharedService.currentLayoutSection = "tabs";
        this.tabConfigObj = this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG];
        this.filterSetupObj = this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG];
        if (this.tabConfigObj == null || this.tabConfigObj.id == null) {
            this.tabConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.TAB_CONFIG
            };
        } else {
            this.tabConfig = JSON.parse(this.tabConfigObj.config);
        }
        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.tabConfig);
        this.sharedService.changedData = this.tabConfig;
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define Filters";
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-tabs";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-tabs";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    saveTabConfig(message) {
        if (message.text == "save-tabs" || message.text == "save-next-tabs") {
            this.filterSetupObj.config = JSON.parse(this.filterSetupObj.config);
            if(this.filterSetupObj.config.standardFields.includes("sessionDateRange") && this.tabConfig.isTabsEnabled) {
                const pnotify = this.notifyService.getPNotify();
                let temp = pnotify.alert({
                title: "Alert",
                text: "You have chosen to enable a Date tabs. The Date range filter will be disabled. Please confirm to proceed",
                addClass: "c-pnotify-confirm",
                hide: false,
                textTrusted: true,
                modules: {
                    Confirm: {
                        confirm: true,
                        align: "flex-end",
                        buttons: [
                            {
                                text: "Ok",
                                textTrusted: false,
                                addClass: "",
                                primary: true,
                                promptTrigger: true,
                                click: (notice, value) => {
                                    let replaceIndex = null;
                                    if(this.filterSetupObj.config.standardFields.includes("sessionDateRange")) {
                                        let temp = []
                                        let tempArr = []
                                        this.filterSetupObj.config.standardFields.forEach(element => {
                                            if(element != "sessionDateRange") {
                                                temp.push(element)
                                            }
                                        });

                                        this.filterSetupObj.config.selectedFields.forEach(element => {
                                            if(element.field != "sessionDateRange") {
                                                tempArr.push(element)
                                            }
                                        });

                                        this.filterSetupObj.config.standardFields = temp;
                                        this.filterSetupObj.config.selectedFields = tempArr;
                                        this.filterSetupObj.config = JSON.stringify(this.filterSetupObj.config);
                                        this.catalogService.saveSetupConfig(this.filterSetupObj).subscribe((resp) => {

                                        })
                                    }
                                    this.tabConfigObj.config = JSON.stringify(this.tabConfig);
                                    this.catalogService.saveSetupConfig(this.tabConfigObj).subscribe((resp) => {
                                        // For checking unsaved data
                                        this.sharedService.createCss(this.catalogService);
                                        this.sharedService.originalData = cloneDeep(this.tabConfig);
                                        this.sharedService.changedData = this.tabConfig;

                                        this.tabConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                                        this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG] = this.tabConfigObj;
                                        this._flashMessagesService.show("Tabs saved successfully.", {
                                            cssClass: "alert-success"
                                        });
                                        if (message.text == "save-next-tabs") {
                                            this.sharedService.currentLayoutSection = "filter";
                                            this.sharedService.catalogNavigateHelper("admin", "catalog/layout/filter");
                                        }
                                        notice.close();
                                        notice.fire("pnotify.confirm", { notice, value });
                                    });
                                    return true;
                                }
                            },
                            {
                                text: "Cancel",
                                textTrusted: false,
                                addClass: "unsaved-btn--secondary",
                                primary: true,
                                promptTrigger: true,
                                click: (notice, value) => {
                                    this.filterSetupObj.config = JSON.stringify(this.filterSetupObj.config);
                                    notice.close();
                                    notice.fire("pnotify.cancel", { notice, value });
                                    return false;
                                }
                            }
                        ]
                    },
                    Buttons: {
                        closer: false,
                        sticker: false
                    }
                },
                stack: {
                    modal: true
                }
                });
            } else {
                this.filterSetupObj.config = JSON.stringify(this.filterSetupObj.config);
                this.tabConfigObj.config = JSON.stringify(this.tabConfig);
                this.catalogService.saveSetupConfig(this.tabConfigObj).subscribe((resp) => {
                    // For checking unsaved data
                    this.sharedService.createCss(this.catalogService);
                    this.sharedService.originalData = cloneDeep(this.tabConfig);
                    this.sharedService.changedData = this.tabConfig;

                    this.tabConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                    this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG] = this.tabConfigObj;
                    this._flashMessagesService.show("Tabs saved successfully.", {
                        cssClass: "alert-success"
                    });
                    if (message.text == "save-next-tabs") {
                        this.sharedService.currentLayoutSection = "filter";
                        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/filter");
                    }
                });
                    
            }
            
        } else if (message.text == "apply-tab-config") {
            this.tabConfig = cloneDeep(this.sharedService.tabsConfig);
            // For checking unsaved data
            this.sharedService.changedData = this.tabConfig;

            this.drawerService.hideDrawer();
        }
    }

    toggleTabsEnable(e) {
        this.tabConfig.isTabsEnabled = !this.tabConfig.isTabsEnabled;
    }

    openConfigDrawer(item) {
        this.sharedService.currentDrawer = {
            title: "Edit Tabs",
            navLinks: null,
            saveMessage: "apply-tab-config"
        };
        this.drawerService.toggleDrawer("small");
        let url = "";
        if (item == "tab") {
            this.sharedService.tabsConfig = cloneDeep(this.tabConfig);
            url = "config-drawer/tab-config";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }
}
